module.exports = __webpack_public_path__ + "img/scientificIcon04.d6afeeed.png";